import initialState from '../initialState';
import * as types from 'actions/actionTypes';

export default function (state = initialState.reducerItemListCatalogDimensions, action) {
    switch (action.type) {
        case types.ITEM_LIST_CATALOG_DIMENSIONS_FULFILLED:
            return {
                itemListCatalogDimensions: action.payload ? action.payload.data.results : [{}],
                isItemListCatalogDimensionsLoaded: true
            }
        default:
            return state;
    }
}
